<template>
  <v-form v-model="valid" :ref="$options.name">
    <h5>{{ $t('registration.subtitles.address') }}</h5>
    <v-layout wrap>
      <v-flex xs12 sm8>
        <v-text-field
          ref="address"
          :value="value.address"
          @input="update('address', $refs.address.lazyValue)"
          :rules="addressRules"
          :label="$t('registration.playerForm.address1')"
          required
        />
      </v-flex>
      <v-flex xs6 sm4 class="pr-1">
        <v-text-field
          ref="address2"
          :value="value.address2"
          @input="update('address2', $refs.address2.lazyValue)"
          :rules="address2Rules"
          :label="$t('registration.playerForm.address2')"
        />
      </v-flex>
      <v-flex xs12 sm7 class="px-1">
        <v-text-field
          ref="city"
          :value="value.city"
          @input="update('city', $refs.city.lazyValue)"
          :rules="cityRules"
          :label="$t('registration.playerForm.city')"
          required
        />
      </v-flex>
      <v-flex xs6 sm2 class="px-1">
        <v-autocomplete
          ref="state"
          :value="value.state"
          @input="update('state', $refs.state.lazyValue)"
          :items="states"
          :rules="stateRules"
          item-text="name"
          item-value="abbreviation"
          :label="stateLabel"
          required
        />
      </v-flex>
      <v-flex xs6 sm3 class="px-1">
        <v-text-field
          ref="zip"
          :value="value.zip"
          @input="update('zip', $refs.zip.lazyValue)"
          :rules="zipRules"
          :label="zipLabel"
          :mask="zipMask"
          required
        />
      </v-flex>
      <v-flex>
        <v-radio-group
        :label="$t('registration.playerForm.country')+':'"
        ref="country"
        :value="value.country"
        @change="update('country', $refs.country.lazyValue)"
        :rules="countryRules"
        row
        mandatory
      >
        <v-radio
          :label="$t('registration.playerForm.citizen_us')"
          value="USA"
        />
        <v-radio
          :label="$t('registration.playerForm.citizen_can')"
          value="CAN"
        />
        <v-radio
          :label="$t('registration.playerForm.citizen_other')"
          value="Other"
        />
      </v-radio-group>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import statesUSJson from '@/assets/states_us.json'
import statesCANJson from '@/assets/states_can.json'

export default {
  name: 'PlayerAddress',
  props: {
    value: Object
  },
  data() {
    return {
      valid: false,
      addressRules: [ (v) => !!v || this.$t('validation.addressRequired') ],
      address2Rules: [],
      cityRules: [ (v) => !!v || this.$t('validation.cityRequired') ],
      stateRules: [ (v) => !!v || this.$t('validation.stateRequired') ],
      zipRules: [ (v) => !!v || this.$t('validation.zipRequired') ],
      countryRules: [ (v) => !!v || this.$t('validation.countryRequired') ],
    }
  },
  computed: {
    states () {
      switch (this.value.country || this.teamCountry) {
        case 'USA':
          return statesUSJson
        case 'US':
          return statesUSJson
        case 'CAN':
          return statesCANJson
        case 'CA':
          return statesCANJson
        default:
          return statesUSJson
      }
    },
    teamCountry () {
      return this.$store.state.team ? this.$store.state.team.country : 'CAN'
    },
    zipMask () {
      switch (this.value.country || this.teamCountry) {
        case 'USA':
          return this.$t('inputMasks.usZip')
        case 'US':
          return this.$t('inputMasks.usZip')
        case 'CAN':
          return this.$t('inputMasks.canZip')
        case 'CA':
          return this.$t('inputMasks.canZip')
        default:
          return this.$t('inputMasks.usZip')
      }
    },
    stateLabel () {
      switch (this.value.country || this.teamCountry) {
        case 'USA':
          return this.$t('registration.playerForm.state_us')
        case 'US':
          return this.$t('registration.playerForm.state_us')
        case 'CAN':
          return this.$t('registration.playerForm.state_can')
        case 'CA':
          return this.$t('registration.playerForm.state_can')
        default:
          return this.$t('registration.playerForm.state_us')
      }
    },
    zipLabel () {
      switch (this.value.country || this.teamCountry) {
        case 'USA':
          return this.$t('registration.playerForm.zip_us')
        case 'US':
          return this.$t('registration.playerForm.zip_us')
        case 'CAN':
          return this.$t('registration.playerForm.zip_can')
        case 'CA':
          return this.$t('registration.playerForm.zip_can')
        default:
          return this.$t('registration.playerForm.zip_us')
      }
    }
  },
  methods: {
    update (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    validate () {
      return this.$refs[this.$options.name].validate()
    }
  }
}
</script>

<style scoped>

</style>